import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ComingSoon } from '@/components/common/coming-soon'

const usedVehicleBuyerSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute(
  '/_authenticated/used-vehicle-buyer/planning/'
)({
  validateSearch: usedVehicleBuyerSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/used-vehicle-buyer/planning',
        search: { language: 'en' },
      })
    }
  },
  component: () => <ComingSoon title='Used Vehicle Buyer' />,
})
